import { useAppSelector } from 'hooks/reduxHooks'
import { getIsEnabledLuxPlusCruiseInclusions, getIsEnabledLuxPlusDiscountedExperiences, getIsInsuranceAndRefundProtectionLuxPlusBenefitsEnabled } from 'luxPlus/selectors/featureToggle'

/**
 * This hook filters out the benefits that are not enabled based on the current feature flags.
 * The returned benefits are the ones that are enabled and used in a few components where we need to show the benefits.
 * Like the LuxPlusBenefitsList, LuxPlusBenefitsModal, accountPage and Landing page component.
 * Note: Currently there is one exception which is the LuxPlusSubscriptionInflowUpsell component
 * where the benefits are hardcoded.
 */
function useEnabledLuxPlusBenefits(benefits?: Array<App.OfferSubscriptionBenefitItem | App.MemberSubscriptionBenefit>) {
  const areInsuranceAndBookingProtectEnabled = useAppSelector(getIsInsuranceAndRefundProtectionLuxPlusBenefitsEnabled)
  const areCruiseInclusionsEnabled = useAppSelector(getIsEnabledLuxPlusCruiseInclusions)
  const areDiscountedExperiencesEnabled = useAppSelector(getIsEnabledLuxPlusDiscountedExperiences)

  if (!benefits || benefits.length === 0) return []

  const excludedBenefitTypes: Array<App.LuxPlusBenefitType> = []
  !areCruiseInclusionsEnabled && excludedBenefitTypes.push('cruise_inclusions')
  !areInsuranceAndBookingProtectEnabled && excludedBenefitTypes.push('discounted_insurance')
  !areDiscountedExperiencesEnabled && excludedBenefitTypes.push('discounted_experiences')

  return excludedBenefitTypes.length ? benefits.filter(benefit => !excludedBenefitTypes.includes(benefit.type)) : benefits
}

export default useEnabledLuxPlusBenefits
